@if (isTemplate1) {
<!-- ── TEMPLATE 1 (OTT) chrome. Same bindings and handlers as the template-0
     branch below — only the markup and styling differ. ── -->
<div id="st_all_events_t1_container" class="t1-ev-page" [class.t1-ev-page--embedded]="is_sub_license">

  <div id="st_all_events_t1_filters" class="t1-ev-filters">
    <div id="st_all_events_t1_tabs" class="t1-ev-tabs" role="tablist">
      @for (item of tabs; track item.id) {
      <button type="button" role="tab" class="t1-ev-tab" [id]="'st_all_events_t1_tab' + item.id"
        [class.t1-ev-tab--on]="selected_tab == item.id" [attr.aria-selected]="selected_tab == item.id"
        (click)="tab_change(item.id)">
        {{ item.title | translate }}
      </button>
      }
    </div>

    <div class="t1-ev-filters__right">
      <div id="st_all_events_t1_view_toggle" class="t1-ev-view-toggle" role="group"
        [attr.aria-label]="'template1_events_view_mode' | translate">
        <button type="button" class="t1-ev-view-btn" id="st_all_events_t1_view_grid"
          [class.t1-ev-view-btn--on]="grid_view" [attr.aria-pressed]="grid_view"
          [attr.aria-label]="'template1_events_grid_view' | translate"
          [attr.title]="'template1_events_grid_view' | translate" (click)="setGridView(true)">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <rect x="3" y="3" width="7" height="7" rx="1" />
            <rect x="14" y="3" width="7" height="7" rx="1" />
            <rect x="3" y="14" width="7" height="7" rx="1" />
            <rect x="14" y="14" width="7" height="7" rx="1" />
          </svg>
        </button>
        <button type="button" class="t1-ev-view-btn" id="st_all_events_t1_view_list"
          [class.t1-ev-view-btn--on]="!grid_view" [attr.aria-pressed]="!grid_view"
          [attr.aria-label]="'template1_events_list_view' | translate"
          [attr.title]="'template1_events_list_view' | translate" (click)="setGridView(false)">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <line x1="8" y1="6" x2="21" y2="6" />
            <line x1="8" y1="12" x2="21" y2="12" />
            <line x1="8" y1="18" x2="21" y2="18" />
            <line x1="3" y1="6" x2="3.01" y2="6" />
            <line x1="3" y1="12" x2="3.01" y2="12" />
            <line x1="3" y1="18" x2="3.01" y2="18" />
          </svg>
        </button>
      </div>

      @if (isT1Mobile) {
      <!-- Phone only: same shared collapsible search bar the Live
             Scorecard page uses, replacing the always-expanded inline box
             below for this breakpoint only — desktop keeps that box as-is. -->
      <stupa-common-search-bar id="st_all_events_t1_search" class="t1-ev-search"
        [searchPlaceholder]="'search_by_event_name' | translate" [searchQuery]="searchQuery"
        (searchChange)="onSearchChange($event)" (inputExpandedChange)="onSearchBarInputExpanded($event)">
      </stupa-common-search-bar>
      } @else {
      <div id="st_all_events_t1_search" class="t1-ev-search">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.35-4.35" />
        </svg>
        <input #t1Search type="text" [value]="searchQuery" [placeholder]="'search_by_event_name' | translate"
          [attr.aria-label]="'search_by_event_name' | translate" (input)="onSearchChange(t1Search.value)" />
      </div>
      }

      <!-- Phone: the four filters move into the bottom drawer below, so this is
           the only control the bar keeps. Hidden above the mobile breakpoint. -->
      <button type="button" id="st_all_events_t1_mfilter_btn" class="t1-ev-mfilter"
        [class.t1-ev-mfilter--on]="activeFilterCount" [attr.aria-label]="'filters' | translate"
        [attr.title]="'filters' | translate" [attr.aria-expanded]="t1MobileFiltersOpen"
        (click)="t1MobileFiltersOpen = true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
        </svg>
        @if (activeFilterCount) {
        <span class="t1-ev-mfilter__badge">{{ activeFilterCount }}</span>
        }
      </button>

      @if (!isT1Mobile) {
      <ng-container *ngTemplateOutlet="t1EvFilterControls"></ng-container>
      }
    </div>
  </div>

  <!-- Rendered once, hosted either inline in the bar (desktop) or in the phone
       drawer — never both, so the mat-selects stay single-instance. -->
  <ng-template #t1EvFilterControls>
    <div id="st_all_events_t1_status_filter" class="t1-ev-csel">
      <button type="button" class="t1-ev-csel__btn" [class.t1-ev-csel__btn--on]="selectedEventStatus.length"
        [class.t1-ev-csel__btn--open]="eventStatusSelect.panelOpen"
        (click)="toggleEventStatusFilter(eventStatusSelect)">
        <span class="t1-ev-csel__dot" aria-hidden="true"></span>
        <span class="t1-ev-csel__label">{{ getSelectedEventStatusName() || ('event_status' | translate) }}</span>
        <svg class="t1-ev-csel__chev" [class.t1-ev-csel__chev--hidden]="selectedEventStatus.length" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
      <button type="button" id="st_all_events_t1_status_clear_btn" class="t1-ev-csel__clear"
        *ngIf="selectedEventStatus.length" [attr.aria-label]="'template1_events_clear_filter' | translate"
        [attr.title]="'template1_events_clear_filter' | translate" (click)="clearEventStatusFilter($event)">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
          <line x1="6" y1="6" x2="18" y2="18" />
          <line x1="18" y1="6" x2="6" y2="18" />
        </svg>
      </button>
      <mat-select id="st_all_events_t1_status_select" #eventStatusSelect class="hidden-mat-select" multiple
        [(value)]="selectedEventStatus" (selectionChange)="onEventStatusChange($event.value)"
        [compareWith]="compareFilterValue" [panelClass]="t1SelectPanelClass">
        <div class="t1-ev-csel__panel-header">
          <div class="t1-ev-csel__hd">{{ 'filter_by_status' | translate }}</div>
          <div class="dropdown-search-container" [class.dark-theme]="is_dark">
            <input type="text" class="dropdown-search" [placeholder]="'search_event_statuses' | translate"
              [(ngModel)]="eventStatusSearch" (keydown)="$event.stopPropagation()" />
          </div>
        </div>
        <mat-option [id]="'st_all_events_t1_status_option' + idx"
          *ngFor="let status of filteredEventStatuses; let idx = index; trackBy: trackByIndex"
          [value]="status.status_id">
          <span class="t1-ev-csel__chk" aria-hidden="true"></span>
          <span class="t1-ev-csel__status-dot" *ngIf="getStatusDotColor(status)"
            [style.background]="getStatusDotColor(status)"></span>
          {{ status.status_description | translate | uppercase }}
        </mat-option>
      </mat-select>
    </div>

    <div id="st_all_events_t1_season_filter" class="t1-ev-csel" *ngIf="!isBroadcastRoute">
      <button type="button" class="t1-ev-csel__btn" [class.t1-ev-csel__btn--on]="selectedSeason.length"
        [class.t1-ev-csel__btn--open]="seasonSelect.panelOpen" (click)="toggleSeasonFilter(seasonSelect)">
        <span class="t1-ev-csel__dot" aria-hidden="true"></span>
        <span class="t1-ev-csel__label">{{ getSelectedSeasonName() || ('season' | translate) }}</span>
        <svg class="t1-ev-csel__chev" [class.t1-ev-csel__chev--hidden]="selectedSeason.length" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
      <button type="button" id="st_all_events_t1_season_clear_btn" class="t1-ev-csel__clear"
        *ngIf="selectedSeason.length" [attr.aria-label]="'template1_events_clear_filter' | translate"
        [attr.title]="'template1_events_clear_filter' | translate" (click)="clearSeasonFilter($event)">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
          <line x1="6" y1="6" x2="18" y2="18" />
          <line x1="18" y1="6" x2="6" y2="18" />
        </svg>
      </button>
      <mat-select id="st_all_events_t1_season_select" #seasonSelect class="hidden-mat-select" multiple
        [(value)]="selectedSeason" (selectionChange)="onSeasonChange($event.value)" [compareWith]="compareFilterValue"
        [panelClass]="t1SelectPanelClass">
        <div class="t1-ev-csel__panel-header">
          <div class="t1-ev-csel__hd">{{ 'template1_events_select_season' | translate }}</div>
          <div class="dropdown-search-container" [class.dark-theme]="is_dark">
            <input type="text" class="dropdown-search" [placeholder]="'search_seasons' | translate"
              [(ngModel)]="seasonSearch" (keydown)="$event.stopPropagation()" />
          </div>
        </div>
        <mat-option [id]="'st_all_events_t1_season_option' + idx"
          *ngFor="let season of filteredSeasons; let idx = index; trackBy: trackByIndex" [value]="season.id">
          <span class="t1-ev-csel__chk" aria-hidden="true"></span>{{ season.season_name }}
        </mat-option>
      </mat-select>
    </div>

    <div id="st_all_events_t1_level_filter" class="t1-ev-csel" *ngIf="!isBroadcastRoute">
      <button type="button" class="t1-ev-csel__btn" [class.t1-ev-csel__btn--on]="selectedEventLevel.length"
        [class.t1-ev-csel__btn--open]="eventLevelSelect.panelOpen" (click)="toggleEventLevelFilter(eventLevelSelect)">
        <span class="t1-ev-csel__dot" aria-hidden="true"></span>
        <span class="t1-ev-csel__label">{{ getSelectedEventLevelName() || ('event_level' | translate) }}</span>
        <svg class="t1-ev-csel__chev" [class.t1-ev-csel__chev--hidden]="selectedEventLevel.length" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
      <button type="button" id="st_all_events_t1_level_clear_btn" class="t1-ev-csel__clear"
        *ngIf="selectedEventLevel.length" [attr.aria-label]="'template1_events_clear_filter' | translate"
        [attr.title]="'template1_events_clear_filter' | translate" (click)="clearEventLevelFilter($event)">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
          <line x1="6" y1="6" x2="18" y2="18" />
          <line x1="18" y1="6" x2="6" y2="18" />
        </svg>
      </button>
      <mat-select id="st_all_events_t1_level_select" #eventLevelSelect class="hidden-mat-select" multiple
        [(value)]="selectedEventLevel" (selectionChange)="onEventLevelChange($event.value)"
        [compareWith]="compareFilterValue" [panelClass]="t1SelectPanelClass">
        <div class="t1-ev-csel__panel-header">
          <div class="t1-ev-csel__hd">{{ 'template1_events_select_level' | translate }}</div>
          <div class="dropdown-search-container" [class.dark-theme]="is_dark">
            <input type="text" class="dropdown-search" [placeholder]="'search_event_levels' | translate"
              [(ngModel)]="eventLevelSearch" (keydown)="$event.stopPropagation()" />
          </div>
        </div>
        <mat-option [id]="'st_all_events_t1_level_option' + idx"
          *ngFor="let level of filteredEventLevels; let idx = index; trackBy: trackByIndex" [value]="level.label">
          <span class="t1-ev-csel__chk" aria-hidden="true"></span>{{ level.label }}
        </mat-option>
      </mat-select>
    </div>

    <div id="st_all_events_t1_date_filter" class="t1-ev-csel">
      <button type="button" class="t1-ev-csel__btn" [class.t1-ev-csel__btn--on]="appliedStartDate || appliedEndDate"
        (click)="openCalendar($event)">
        <span class="t1-ev-csel__dot" aria-hidden="true"></span>
        <span class="t1-ev-csel__label">{{ getDateRangeText() | translate }}</span>
        <svg class="t1-ev-csel__chev" [class.t1-ev-csel__chev--hidden]="appliedStartDate || appliedEndDate"
          viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
      <button type="button" class="t1-ev-csel__clear" *ngIf="appliedStartDate || appliedEndDate"
        [attr.aria-label]="'template1_events_clear_filter' | translate"
        [attr.title]="'template1_events_clear_filter' | translate" (click)="clearDateFilter($event)">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
          <line x1="6" y1="6" x2="18" y2="18" />
          <line x1="18" y1="6" x2="6" y2="18" />
        </svg>
      </button>
    </div>
  </ng-template>

  <!-- Phone filter drawer. `appendTo="body"` is required: `.router-content` is a
       z-index:1 stacking context, so anything left inside it renders under the
       shell's fixed bottom nav no matter what z-index it asks for. -->
  @if (isT1Mobile) {
  <p-sidebar [(visible)]="t1MobileFiltersOpen" position="bottom" [appendTo]="'body'" [showCloseIcon]="false"
    [blockScroll]="true" styleClass="t1-ev-fsheet">
    <ng-template pTemplate="header">
      <span class="t1-ev-fsheet__title">{{ 'filters' | translate }}</span>
      <div class="t1-ev-fsheet__actions">
        <button type="button" id="st_all_events_t1_mfilter_clear_all" class="t1-ev-fsheet__clear-all"
          *ngIf="activeFilterCount" (click)="clearAllFilters($event)">{{ 'clear_all' | translate }}</button>
        <button type="button" id="st_all_events_t1_mfilter_done" class="t1-ev-fsheet__done"
          (click)="t1MobileFiltersOpen = false">{{ 'close' | translate }}</button>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <ng-container *ngTemplateOutlet="t1EvFilterControls"></ng-container>
    </ng-template>
  </p-sidebar>
  }

  <div id="st_all_events_t1_grid" class="t1-ev-grid" [attr.data-ev-view]="grid_view ? 'grid' : 'list'">
    <!-- One loop for both layouts: above the phone breakpoint `t1EventGroups`
         is a single unlabelled group, so desktop keeps the server's ordering
         and renders no headers. -->
    @for (group of t1EventGroups; track group.key) {
    @if (group.label) {
    <div class="t1-ev-group">
      <span class="t1-ev-group__dot" [style.background]="group.color" aria-hidden="true"></span>
      <span class="t1-ev-group__label">{{ group.label | translate }}</span>
      <span class="t1-ev-group__count">{{ group.items.length }}</span>
    </div>
    }
    @for (item of group.items; track item.id) {
    <stupa-template1-event-card [item]="item" [location]="getLocation(item)" [isBroadcastRoute]="isBroadcastRoute"
      (cardClick)="go_to_event(item)" (viewDetails)="go_to_event(item)" (register)="onRegister(item)"
      (newRegister)="onNewRegister(item)"
      (viewRegisterCount)="onViewRegisterCount(item)" (showLogin)="openLoginPopup()">
    </stupa-template1-event-card>
    }
    }

    <!-- Initial load and every search/filter change: `t1-ev-loading` below can't cover this,
         it requires existing rows to show a "loading more" line under (pagination only). Without
         this, the gap between "isLoading flips true" and "the response arrives" rendered nothing
         at all — no spinner, no empty-state (that one also requires `!isLoading`) — just blank. -->
    <div id="st_all_events_t1_skeleton" class="t1-ev-skel-grid" *ngIf="isLoading && events_list?.length === 0"
      aria-hidden="true">
      <div class="t1-ev-skel-card" *ngFor="let _ of t1SkeletonCards">
        <div class="t1-ev-skel-card__media"></div>
        <div class="t1-ev-skel-card__body">
          <div class="t1-ev-skel-card__head">
            <span class="t1-ev-skel-card__pill"></span>
            <span class="t1-ev-skel-card__date"></span>
          </div>
          <span class="t1-ev-skel-card__title"></span>
          <span class="t1-ev-skel-card__stat"></span>
          <span class="t1-ev-skel-card__cta"></span>
        </div>
      </div>
    </div>

    <div id="st_all_events_t1_empty" class="t1-ev-empty" *ngIf="events_list?.length == 0 && !isLoading">
      <stupa-empty-state purpose="no-tournaments" [title]="'no_records_found' | translate"
        [description]="'template1_events_empty_hint' | translate" />
    </div>
  </div>

  <div id="st_all_events_t1_loading" class="t1-ev-loading" *ngIf="isLoading && events_list?.length > 0">
    <stupa-gif-loader></stupa-gif-loader>
    <span>{{ 'loading_more_event' | translate }}</span>
  </div>
</div>
} @else {
<div id="st_all_events_main_container" [ngClass]="{'st_common_high_padding': !is_sub_license, 'mt-2': is_sub_license}"
  class="all-events-container">
  <div class="all-event-topbar-section position-relative">
    <div id="st_all_events_content_wrapper" class="wrapper pt-0">
      <!-- [ngClass]="{'mb-5  pt-2':screenWidth> 1024,'mb-3 ':screenWidth < 1024,
            }" -->
      <div id="st_all_events_header_controls" class="my-2 d-flex align-items-center"
        [ngClass]="screenWidth > 1024 || !searchBarExpanded ? 'justify-content-between' : 'justify-content-end'">
        <div id="st_all_events_tabs_container" class="tab d-flex event-tab-container"
          [ngClass]="{ ' gap-2': screenWidth > 1024, 'gap-1': screenWidth < 1024 }"
          [class.st-compact-nav-tabs]="screenWidth <= 1024 && searchBarExpanded">
          @for(item of tabs; track item.id){
          <div [id]="'st_all_events_tab_item' + (item.id)" class="tab_item" (click)="tab_change(item.id)" [ngClass]="{
            selected: selected_tab == item.id,
            mobile_screen: screenWidth < 1024
          }">
            {{ item.title | translate}}
          </div>
          }
        </div>
        <div id="st_all_events_search_and_filters" class="st-filter-actions-bar-wrap gap-2 d-flex align-items-center"
          [class.w-100]="screenWidth < 600 && searchBarExpanded">
          <!-- Desktop: compact inline search input. Mobile: shared collapsible search-bar component. -->
          <ng-container *ngIf="screenWidth > 1024; else st_all_events_mobile_search">
            <div id="st_all_events_search_container" class="search-container">
              <div id="st_all_events_inner_search" class="inner_search">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.9118 15.8626L9.15447 10.1052C8.69613 10.4836 8.16905 10.7798 7.57322 10.9937C6.97738 11.2076 6.36099 11.3145 5.72402 11.3145C4.15729 11.3145 2.83131 10.772 1.7461 9.6871C0.660892 8.60216 0.118286 7.27653 0.118286 5.71021C0.118286 4.14387 0.660754 2.81775 1.74569 1.73185C2.83063 0.645969 4.15626 0.103027 5.7226 0.103027C7.28893 0.103027 8.61504 0.645634 9.70094 1.73085C10.7868 2.81606 11.3298 4.14203 11.3298 5.70877C11.3298 6.36336 11.2199 6.98857 11.0001 7.5844C10.7804 8.18024 10.4871 8.6985 10.1205 9.13921L15.8778 14.8966L14.9118 15.8626ZM5.72402 9.93955C6.90512 9.93955 7.90552 9.52969 8.72524 8.70998C9.54495 7.89026 9.95481 6.88986 9.95481 5.70877C9.95481 4.52767 9.54495 3.52727 8.72524 2.70755C7.90552 1.88784 6.90512 1.47798 5.72402 1.47798C4.54293 1.47798 3.54253 1.88784 2.72281 2.70755C1.90311 3.52727 1.49326 4.52767 1.49326 5.70877C1.49326 6.88986 1.90311 7.89026 2.72281 8.70998C3.54253 9.52969 4.54293 9.93955 5.72402 9.93955Z"
                    fill="currentColor" />
                </svg>
                <input type="text" class="form-control search-input" [placeholder]="'search_by_event_name' | translate"
                  [ngModel]="searchQuery" (ngModelChange)="onSearchChange($event)">
              </div>
            </div>
          </ng-container>

          <!-- Mobile: unchanged — shared search-bar component owns its own
               collapsible responsive behavior (searchBarExpanded). -->
          <ng-template #st_all_events_mobile_search>
            <stupa-common-search-bar id="st_all_events_search_bar"
              [searchPlaceholder]="'search_by_event_name' | translate" [class.w-100]="searchBarExpanded"
              [searchQuery]="searchQuery" (searchChange)="onSearchChange($event)"
              (inputExpandedChange)="onSearchBarInputExpanded($event)">
            </stupa-common-search-bar>
          </ng-template>

          @if (screenWidth > 1024) {
          <!-- Desktop: same compact view-toggle bar as events results/schedule. -->
          <div id="st_all_events_view_toggle_container" class="view-toggle">
            <button type="button" id="st_all_events_view_toggle_btn_grid" class="view-toggle-btn p-links"
              [class.active]="viewMode === 'grid'" [title]="'grid_view'|translate"
              [attr.aria-label]="'grid_view'|translate" [attr.aria-pressed]="viewMode === 'grid'"
              (click)="setViewMode('grid')">
              <svg width="14" height="14" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0 8H8V0H0M2 2H6V6H2M10 18H18V10H10M12 12H16V16H12M0 18H8V10H0M2 12H6V16H2M10 0V8H18V0M16 6H12V2H16V6Z" />
              </svg>
            </button>
            <button type="button" id="st_all_events_view_toggle_btn_list" class="view-toggle-btn p-links"
              [class.active]="viewMode === 'list'" [title]="'Table_View'|translate"
              [attr.aria-label]="'Table_View'|translate" [attr.aria-pressed]="viewMode === 'list'"
              (click)="setViewMode('list')">
              <svg width="14" height="12" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6 15V13H18V15H6ZM6 9.00001V7.00001H18V9.00001H6ZM6 3.00001V1.00001H18V3.00001H6ZM2 16C1.45 16 0.979335 15.8043 0.588002 15.413C0.196668 15.0217 0.000668362 14.5507 1.69491e-06 14C-0.000664972 13.4493 0.195335 12.9787 0.588002 12.588C0.980668 12.1973 1.45133 12.0013 2 12C2.54867 11.9987 3.01967 12.1947 3.413 12.588C3.80634 12.9813 4.002 13.452 4 14C3.998 14.548 3.80234 15.019 3.413 15.413C3.02367 15.807 2.55267 16.0027 2 16ZM2 10C1.45 10 0.979335 9.80434 0.588002 9.41301C0.196668 9.02167 0.000668362 8.55067 1.69491e-06 8.00001C-0.000664972 7.44934 0.195335 6.97867 0.588002 6.58801C0.980668 6.19734 1.45133 6.00134 2 6.00001C2.54867 5.99867 3.01967 6.19467 3.413 6.58801C3.80634 6.98134 4.002 7.45201 4 8.00001C3.998 8.54801 3.80234 9.01901 3.413 9.41301C3.02367 9.80701 2.55267 10.0027 2 10ZM2 4.00001C1.45 4.00001 0.979335 3.80434 0.588002 3.41301C0.196668 3.02167 0.000668362 2.55067 1.69491e-06 2.00001C-0.000664972 1.44934 0.195335 0.978673 0.588002 0.588007C0.980668 0.19734 1.45133 0.00134009 2 6.75676e-06C2.54867 -0.00132658 3.01967 0.194673 3.413 0.588007C3.80634 0.98134 4.002 1.45201 4 2.00001C3.998 2.54801 3.80234 3.01901 3.413 3.41301C3.02367 3.80701 2.55267 4.00267 2 4.00001Z" />
              </svg>
            </button>
            <button type="button" id="st_all_events_view_toggle_btn_map" class="view-toggle-btn p-links"
              [class.active]="viewMode === 'map'" [title]="'Map_View'|translate"
              [attr.aria-label]="'Map_View'|translate" [attr.aria-pressed]="viewMode === 'map'"
              (click)="setViewMode('map')">
              <svg width="14" height="14" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <path
                  d="M9 1.5C6.1 1.5 3.75 3.85 3.75 6.75C3.75 10.69 9 16.5 9 16.5C9 16.5 14.25 10.69 14.25 6.75C14.25 3.85 11.9 1.5 9 1.5ZM9 8.75C7.9 8.75 7 7.85 7 6.75C7 5.65 7.9 4.75 9 4.75C10.1 4.75 11 5.65 11 6.75C11 7.85 10.1 8.75 9 8.75Z" />
              </svg>
            </button>
          </div>
          } @else {
          <!-- Mobile: one filter button opens the drawer so the chip row does not
               sit above the map and event list. -->
          <button type="button" id="st_all_events_mobile_filter_btn" class="filter-icon-btn p-links flex-shrink-0"
            [attr.aria-expanded]="mobileFiltersOpen" [attr.aria-label]="'filters' | translate"
            [title]="'filters' | translate" (click)="openMobileFilters()">
            <svg width="16" height="14" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true">
              <path
                d="M14.1827 15.0163C13.3238 15.0163 12.5979 14.7198 12.0049 14.1268C11.4119 13.5338 11.1154 12.8079 11.1154 11.9491C11.1154 11.0902 11.4119 10.3643 12.0049 9.77129C12.5979 9.17828 13.3238 8.88178 14.1827 8.88178C15.0415 8.88178 15.7674 9.17828 16.3604 9.77129C16.9534 10.3643 17.25 11.0902 17.25 11.9491C17.25 12.8079 16.9534 13.5338 16.3604 14.1268C15.7674 14.7198 15.0415 15.0163 14.1827 15.0163ZM14.1818 13.6414C14.6489 13.6414 15.0479 13.4763 15.3787 13.146C15.7096 12.8158 15.875 12.4171 15.875 11.95C15.875 11.4828 15.7099 11.0838 15.3796 10.753C15.0494 10.4222 14.6507 10.2568 14.1835 10.2568C13.7164 10.2568 13.3174 10.4219 12.9866 10.7521C12.6558 11.0823 12.4903 11.481 12.4903 11.9482C12.4903 12.4153 12.6555 12.8143 12.9857 13.1451C13.3159 13.476 13.7146 13.6414 14.1818 13.6414ZM2.125 12.6365V11.2616H9.10576V12.6365H2.125ZM3.81728 7.11894C2.95846 7.11894 2.23253 6.82243 1.63951 6.22943C1.0465 5.63642 0.75 4.9105 0.75 4.05166C0.75 3.19282 1.0465 2.46689 1.63951 1.87389C2.23253 1.28088 2.95846 0.984375 3.81728 0.984375C4.67612 0.984375 5.40205 1.28088 5.99505 1.87389C6.58806 2.46689 6.88456 3.19282 6.88456 4.05166C6.88456 4.9105 6.58806 5.63642 5.99505 6.22943C5.40205 6.82243 4.67612 7.11894 3.81728 7.11894ZM3.81641 5.74396C4.28356 5.74396 4.68255 5.57885 5.01337 5.24862C5.3442 4.91839 5.50961 4.5197 5.50961 4.05255C5.50961 3.58539 5.34449 3.18639 5.01426 2.85557C4.68404 2.52474 4.28534 2.35933 3.81818 2.35933C3.35103 2.35933 2.95204 2.52445 2.62121 2.85469C2.29039 3.18492 2.12498 3.58361 2.12498 4.05076C2.12498 4.51791 2.29009 4.9169 2.62032 5.24772C2.95055 5.57855 3.34925 5.74396 3.81641 5.74396ZM8.89419 4.73913V3.36418H15.875V4.73913H8.89419Z" />
            </svg>
            @if (appliedDiscoveryFilterCount() > 0) {
            <span class="events-filter-count-badge position-absolute top-0 end-0 fs-8 fw-semibold">{{
              appliedDiscoveryFilterCount() }}</span>
            }
          </button>
          <!-- Mobile: grid/list cycle sized to the search bar's collapsed icon
               (see st-filter-actions-bar-wrap `respond-to(md)` in
               all-events.component.scss), plus the map view button. -->
          @if(!searchBarExpanded){
          <div id="st_all_events_view_toggle_container_mobile" class="view-toggle view-toggle--single" role="group"
            [attr.aria-label]="'view' | translate">
            <button type="button" id="st_all_events_view_toggle_btn_mobile" class="view-toggle-btn p-links"
              [class.active]="viewMode !== 'map'"
              [title]="(viewMode === 'list' ? 'Table_View' : 'grid_view') | translate"
              [attr.aria-label]="(viewMode === 'list' ? 'Table_View' : 'grid_view') | translate"
              [attr.aria-pressed]="viewMode !== 'map'" (click)="change_grid()">
              @if (viewMode !== 'list') {
              <svg width="14" height="14" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0 8H8V0H0M2 2H6V6H2M10 18H18V10H10M12 12H16V16H12M0 18H8V10H0M2 12H6V16H2M10 0V8H18V0M16 6H12V2H16V6Z" />
              </svg>
              } @else {
              <svg width="14" height="12" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6 15V13H18V15H6ZM6 9.00001V7.00001H18V9.00001H6ZM6 3.00001V1.00001H18V3.00001H6ZM2 16C1.45 16 0.979335 15.8043 0.588002 15.413C0.196668 15.0217 0.000668362 14.5507 1.69491e-06 14C-0.000664972 13.4493 0.195335 12.9787 0.588002 12.588C0.980668 12.1973 1.45133 12.0013 2 12C2.54867 11.9987 3.01967 12.1947 3.413 12.588C3.80634 12.9813 4.002 13.452 4 14C3.998 14.548 3.80234 15.019 3.413 15.413C3.02367 15.807 2.55267 16.0027 2 16ZM2 10C1.45 10 0.979335 9.80434 0.588002 9.41301C0.196668 9.02167 0.000668362 8.55067 1.69491e-06 8.00001C-0.000664972 7.44934 0.195335 6.97867 0.588002 6.58801C0.980668 6.19734 1.45133 6.00134 2 6.00001C2.54867 5.99867 3.01967 6.19467 3.413 6.58801C3.80634 6.98134 4.002 7.45201 4 8.00001C3.998 8.54801 3.80234 9.01901 3.413 9.41301C3.02367 9.80701 2.55267 10.0027 2 10ZM2 4.00001C1.45 4.00001 0.979335 3.80434 0.588002 3.41301C0.196668 3.02167 0.000668362 2.55067 1.69491e-06 2.00001C-0.000664972 1.44934 0.195335 0.978673 0.588002 0.588007C0.980668 0.19734 1.45133 0.00134009 2 6.75676e-06C2.54867 -0.00132658 3.01967 0.194673 3.413 0.588007C3.80634 0.98134 4.002 1.45201 4 2.00001C3.998 2.54801 3.80234 3.01901 3.413 3.41301C3.02367 3.80701 2.55267 4.00267 2 4.00001Z" />
              </svg>
              }
            </button>
            <button type="button" id="st_all_events_view_toggle_btn_map_mobile"
              class="view-toggle-btn view-toggle-btn--map p-links" [class.active]="viewMode === 'map'"
              [title]="'Map_View'|translate" [attr.aria-label]="'Map_View'|translate"
              [attr.aria-pressed]="viewMode === 'map'" (click)="setViewMode('map')">
              <svg width="14" height="14" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <path
                  d="M9 1.5C6.1 1.5 3.75 3.85 3.75 6.75C3.75 10.69 9 16.5 9 16.5C9 16.5 14.25 10.69 14.25 6.75C14.25 3.85 11.9 1.5 9 1.5ZM9 8.75C7.9 8.75 7 7.85 7 6.75C7 5.65 7.9 4.75 9 4.75C10.1 4.75 11 5.65 11 6.75C11 7.85 10.1 8.75 9 8.75Z" />
              </svg>
            </button>
          </div>}
          }
        </div>
      </div>
    </div>
    @if (screenWidth > 1024) {
    <div id="st_all_events_desktop_filters_container" class="filter-container justify-content-end"
      [class.dark-theme]="is_dark" [ngClass]="screenWidth < 600 ?'mb-2':'mb-4'">
      <div id="st_all_events_status_filter_wrapper" class="filter-button-wrapper">
        <button class="filter-button" [class.active]="selectedEventStatus.length" (click)="eventStatusSelect.open()">
          <span class="filter-button-text">{{ getSelectedEventStatusName() || ('event_status'|translate) }}</span>
          <svg *ngIf="selectedEventStatus.length" class="filter-close-icon" width="16" height="17" viewBox="0 0 16 17"
            fill="none" xmlns="http://www.w3.org/2000/svg" (click)="clearEventStatusFilter($event)">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M8 16.5381C10.1217 16.5381 12.1566 15.6952 13.6569 14.1949C15.1571 12.6946 16 10.6598 16 8.53809C16 6.41635 15.1571 4.38152 13.6569 2.88123C12.1566 1.38094 10.1217 0.538086 8 0.538086C5.87827 0.538086 3.84344 1.38094 2.34315 2.88123C0.842855 4.38152 0 6.41635 0 8.53809C0 10.6598 0.842855 12.6946 2.34315 14.1949C3.84344 15.6952 5.87827 16.5381 8 16.5381ZM6.28 5.75809C6.13783 5.62561 5.94978 5.55348 5.75548 5.55691C5.56118 5.56034 5.37579 5.63905 5.23838 5.77646C5.10097 5.91388 5.02225 6.09926 5.01883 6.29356C5.0154 6.48786 5.08752 6.67591 5.22 6.81809L6.94 8.53809L5.22 10.2581C5.14631 10.3267 5.08721 10.4095 5.04622 10.5015C5.00523 10.5935 4.98319 10.6929 4.98141 10.7936C4.97963 10.8943 4.99816 10.9943 5.03588 11.0877C5.0736 11.1811 5.12974 11.2659 5.20096 11.3371C5.27218 11.4083 5.35701 11.4645 5.4504 11.5022C5.54379 11.5399 5.64382 11.5585 5.74452 11.5567C5.84523 11.5549 5.94454 11.5329 6.03654 11.4919C6.12854 11.4509 6.21134 11.3918 6.28 11.3181L8 9.59809L9.72 11.3181C9.78866 11.3918 9.87146 11.4509 9.96346 11.4919C10.0555 11.5329 10.1548 11.5549 10.2555 11.5567C10.3562 11.5585 10.4562 11.5399 10.5496 11.5022C10.643 11.4645 10.7278 11.4083 10.799 11.3371C10.8703 11.2659 10.9264 11.1811 10.9641 11.0877C11.0018 10.9943 11.0204 10.8943 11.0186 10.7936C11.0168 10.6929 10.9948 10.5935 10.9538 10.5015C10.9128 10.4095 10.8537 10.3267 10.78 10.2581L9.06 8.53809L10.78 6.81809C10.9125 6.67591 10.9846 6.48786 10.9812 6.29356C10.9777 6.09926 10.899 5.91388 10.7616 5.77646C10.6242 5.63905 10.4388 5.56034 10.2445 5.55691C10.0502 5.55348 9.86217 5.62561 9.72 5.75809L8 7.47809L6.28 5.75809Z"
              fill="currentColor" />
          </svg>
          <svg *ngIf="!selectedEventStatus.length" class="filter-arrow" width="12" height="8" viewBox="0 0 12 8"
            fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
        <mat-select id="st_all_events_status_select" #eventStatusSelect class="hidden-mat-select" multiple
          [(ngModel)]="pendingEventStatus" [compareWith]="compareFilterValues"
          (openedChange)="onEventStatusPanelToggle($event)"
          [panelClass]="is_dark ? 'dark-theme-dropdown events-filter-panel' : 'events-filter-panel'">
          <div id="st_all_events_status_search_container" class="dropdown-search-container"
            [class.dark-theme]="is_dark">
            <input type="text" class="dropdown-search" [placeholder]="'search_event_statuses'|translate"
              [(ngModel)]="eventStatusSearch" (keydown)="$event.stopPropagation()">
          </div>
          <mat-option [id]="'st_all_events_status_option' + idx"
            *ngFor="let status of filteredEventStatuses; let idx = index; trackBy: trackByIndex"
            [value]="'' + status.status_id">
            {{ status.status_description|translate|uppercase }}
          </mat-option>
          <div class="dropdown-apply-container p-2" [class.dark-theme]="is_dark" (click)="$event.stopPropagation()">
            <button type="button"
              class="dropdown-apply-btn d-flex align-items-center justify-content-center gap-1 fs-13 fw-medium py-2 lh-1"
              (click)="applyEventStatusFilter()">
              <span>{{ 'apply' | translate }}</span>
              <span
                class="dropdown-apply-count d-inline-flex align-items-center justify-content-center rounded-pill fs-10 fw-semibold lh-1">{{
                pendingEventStatus.length }}</span>
            </button>
          </div>
        </mat-select>
      </div>

      <div id="st_all_events_season_filter_wrapper" class="filter-button-wrapper" *ngIf="!isBroadcastRoute">
        <button class="filter-button" [class.active]="selectedSeason.length" (click)="seasonSelect.open()">
          <span class="filter-button-text">{{ getSelectedSeasonName() || ('season'|translate) }}</span>
          <svg *ngIf="selectedSeason.length" class="filter-close-icon" width="16" height="17" viewBox="0 0 16 17"
            fill="none" xmlns="http://www.w3.org/2000/svg" (click)="clearSeasonFilter($event)">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M8 16.5381C10.1217 16.5381 12.1566 15.6952 13.6569 14.1949C15.1571 12.6946 16 10.6598 16 8.53809C16 6.41635 15.1571 4.38152 13.6569 2.88123C12.1566 1.38094 10.1217 0.538086 8 0.538086C5.87827 0.538086 3.84344 1.38094 2.34315 2.88123C0.842855 4.38152 0 6.41635 0 8.53809C0 10.6598 0.842855 12.6946 2.34315 14.1949C3.84344 15.6952 5.87827 16.5381 8 16.5381ZM6.28 5.75809C6.13783 5.62561 5.94978 5.55348 5.75548 5.55691C5.56118 5.56034 5.37579 5.63905 5.23838 5.77646C5.10097 5.91388 5.02225 6.09926 5.01883 6.29356C5.0154 6.48786 5.08752 6.67591 5.22 6.81809L6.94 8.53809L5.22 10.2581C5.14631 10.3267 5.08721 10.4095 5.04622 10.5015C5.00523 10.5935 4.98319 10.6929 4.98141 10.7936C4.97963 10.8943 4.99816 10.9943 5.03588 11.0877C5.0736 11.1811 5.12974 11.2659 5.20096 11.3371C5.27218 11.4083 5.35701 11.4645 5.4504 11.5022C5.54379 11.5399 5.64382 11.5585 5.74452 11.5567C5.84523 11.5549 5.94454 11.5329 6.03654 11.4919C6.12854 11.4509 6.21134 11.3918 6.28 11.3181L8 9.59809L9.72 11.3181C9.78866 11.3918 9.87146 11.4509 9.96346 11.4919C10.0555 11.5329 10.1548 11.5549 10.2555 11.5567C10.3562 11.5585 10.4562 11.5399 10.5496 11.5022C10.643 11.4645 10.7278 11.4083 10.799 11.3371C10.8703 11.2659 10.9264 11.1811 10.9641 11.0877C11.0018 10.9943 11.0204 10.8943 11.0186 10.7936C11.0168 10.6929 10.9948 10.5935 10.9538 10.5015C10.9128 10.4095 10.8537 10.3267 10.78 10.2581L9.06 8.53809L10.78 6.81809C10.9125 6.67591 10.9846 6.48786 10.9812 6.29356C10.9777 6.09926 10.899 5.91388 10.7616 5.77646C10.6242 5.63905 10.4388 5.56034 10.2445 5.55691C10.0502 5.55348 9.86217 5.62561 9.72 5.75809L8 7.47809L6.28 5.75809Z"
              fill="currentColor" />
          </svg>
          <svg *ngIf="!selectedSeason.length" class="filter-arrow" width="12" height="8" viewBox="0 0 12 8" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
        <mat-select id="st_all_events_season_select" #seasonSelect class="hidden-mat-select" multiple
          [(ngModel)]="pendingSeason" [compareWith]="compareFilterValues" (openedChange)="onSeasonPanelToggle($event)"
          [panelClass]="is_dark ? 'dark-theme-dropdown events-filter-panel' : 'events-filter-panel'">
          <div id="st_all_events_season_search_container" class="dropdown-search-container"
            [class.dark-theme]="is_dark">
            <input type="text" class="dropdown-search" [placeholder]="'search_seasons'|translate"
              [(ngModel)]="seasonSearch" (keydown)="$event.stopPropagation()">
          </div>
          <mat-option [id]="'st_all_events_season_option' + idx"
            *ngFor="let season of filteredSeasons; let idx = index; trackBy: trackByIndex" [value]="'' + season.id">
            {{ season.season_name }}
          </mat-option>
          <div class="dropdown-apply-container p-2" [class.dark-theme]="is_dark" (click)="$event.stopPropagation()">
            <button type="button"
              class="dropdown-apply-btn d-flex align-items-center justify-content-center gap-1 fs-13 fw-medium py-2 lh-1"
              (click)="applySeasonFilter()">
              <span>{{ 'apply' | translate }}</span>
              <span
                class="dropdown-apply-count d-inline-flex align-items-center justify-content-center rounded-pill fs-10 fw-semibold lh-1">{{
                pendingSeason.length }}</span>
            </button>
          </div>
        </mat-select>
      </div>

      <div id="st_all_events_level_filter_wrapper" class="filter-button-wrapper" *ngIf="!isBroadcastRoute">
        <button class="filter-button" [class.active]="selectedEventLevel.length" (click)="eventLevelSelect.open()">
          <span class="filter-button-text">{{ getSelectedEventLevelName() || ('event_level'|translate) }}</span>
          <svg *ngIf="selectedEventLevel.length" class="filter-close-icon" width="16" height="17" viewBox="0 0 16 17"
            fill="none" xmlns="http://www.w3.org/2000/svg" (click)="clearEventLevelFilter($event)">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M8 16.5381C10.1217 16.5381 12.1566 15.6952 13.6569 14.1949C15.1571 12.6946 16 10.6598 16 8.53809C16 6.41635 15.1571 4.38152 13.6569 2.88123C12.1566 1.38094 10.1217 0.538086 8 0.538086C5.87827 0.538086 3.84344 1.38094 2.34315 2.88123C0.842855 4.38152 0 6.41635 0 8.53809C0 10.6598 0.842855 12.6946 2.34315 14.1949C3.84344 15.6952 5.87827 16.5381 8 16.5381ZM6.28 5.75809C6.13783 5.62561 5.94978 5.55348 5.75548 5.55691C5.56118 5.56034 5.37579 5.63905 5.23838 5.77646C5.10097 5.91388 5.02225 6.09926 5.01883 6.29356C5.0154 6.48786 5.08752 6.67591 5.22 6.81809L6.94 8.53809L5.22 10.2581C5.14631 10.3267 5.08721 10.4095 5.04622 10.5015C5.00523 10.5935 4.98319 10.6929 4.98141 10.7936C4.97963 10.8943 4.99816 10.9943 5.03588 11.0877C5.0736 11.1811 5.12974 11.2659 5.20096 11.3371C5.27218 11.4083 5.35701 11.4645 5.4504 11.5022C5.54379 11.5399 5.64382 11.5585 5.74452 11.5567C5.84523 11.5549 5.94454 11.5329 6.03654 11.4919C6.12854 11.4509 6.21134 11.3918 6.28 11.3181L8 9.59809L9.72 11.3181C9.78866 11.3918 9.87146 11.4509 9.96346 11.4919C10.0555 11.5329 10.1548 11.5549 10.2555 11.5567C10.3562 11.5585 10.4562 11.5399 10.5496 11.5022C10.643 11.4645 10.7278 11.4083 10.799 11.3371C10.8703 11.2659 10.9264 11.1811 10.9641 11.0877C11.0018 10.9943 11.0204 10.8943 11.0186 10.7936C11.0168 10.6929 10.9948 10.5935 10.9538 10.5015C10.9128 10.4095 10.8537 10.3267 10.78 10.2581L9.06 8.53809L10.78 6.81809C10.9125 6.67591 10.9846 6.48786 10.9812 6.29356C10.9777 6.09926 10.899 5.91388 10.7616 5.77646C10.6242 5.63905 10.4388 5.56034 10.2445 5.55691C10.0502 5.55348 9.86217 5.62561 9.72 5.75809L8 7.47809L6.28 5.75809Z"
              fill="currentColor" />
          </svg>
          <svg *ngIf="!selectedEventLevel.length" class="filter-arrow" width="12" height="8" viewBox="0 0 12 8"
            fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
        <mat-select id="st_all_events_level_select" #eventLevelSelect class="hidden-mat-select" multiple
          [(ngModel)]="pendingEventLevel" [compareWith]="compareFilterValues"
          (openedChange)="onEventLevelPanelToggle($event)"
          [panelClass]="is_dark ? 'dark-theme-dropdown events-filter-panel' : 'events-filter-panel'">
          <div id="st_all_events_level_search_container" class="dropdown-search-container" [class.dark-theme]="is_dark">
            <input type="text" class="dropdown-search" [placeholder]="'search_event_levels'|translate"
              [(ngModel)]="eventLevelSearch" (keydown)="$event.stopPropagation()">
          </div>
          <mat-option [id]="'st_all_events_level_option' + idx"
            *ngFor="let level of filteredEventLevels; let idx = index; trackBy: trackByIndex" [value]="level.label">
            {{ level.label }}
          </mat-option>
          <div class="dropdown-apply-container p-2" [class.dark-theme]="is_dark" (click)="$event.stopPropagation()">
            <button type="button"
              class="dropdown-apply-btn d-flex align-items-center justify-content-center gap-1 fs-13 fw-medium py-2 lh-1"
              (click)="applyEventLevelFilter()">
              <span>{{ 'apply' | translate }}</span>
              <span
                class="dropdown-apply-count d-inline-flex align-items-center justify-content-center rounded-pill fs-10 fw-semibold lh-1">{{
                pendingEventLevel.length }}</span>
            </button>
          </div>
        </mat-select>
      </div>

      <div id="st_all_events_date_filter_wrapper" class="filter-button-wrapper">
        <button class="filter-button" [class.active]="appliedStartDate || appliedEndDate"
          (click)="openCalendar($event)">
          <span class="filter-button-text">{{ getDateRangeText()|translate }}</span>
          <svg *ngIf="appliedStartDate || appliedEndDate" class="filter-close-icon" width="16" height="17"
            viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="clearDateFilter($event)">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M8 16.5381C10.1217 16.5381 12.1566 15.6952 13.6569 14.1949C15.1571 12.6946 16 10.6598 16 8.53809C16 6.41635 15.1571 4.38152 13.6569 2.88123C12.1566 1.38094 10.1217 0.538086 8 0.538086C5.87827 0.538086 3.84344 1.38094 2.34315 2.88123C0.842855 4.38152 0 6.41635 0 8.53809C0 10.6598 0.842855 12.6946 2.34315 14.1949C3.84344 15.6952 5.87827 16.5381 8 16.5381ZM6.28 5.75809C6.13783 5.62561 5.94978 5.55348 5.75548 5.55691C5.56118 5.56034 5.37579 5.63905 5.23838 5.77646C5.10097 5.91388 5.02225 6.09926 5.01883 6.29356C5.0154 6.48786 5.08752 6.67591 5.22 6.81809L6.94 8.53809L5.22 10.2581C5.14631 10.3267 5.08721 10.4095 5.04622 10.5015C5.00523 10.5935 4.98319 10.6929 4.98141 10.7936C4.97963 10.8943 4.99816 10.9943 5.03588 11.0877C5.0736 11.1811 5.12974 11.2659 5.20096 11.3371C5.27218 11.4083 5.35701 11.4645 5.4504 11.5022C5.54379 11.5399 5.64382 11.5585 5.74452 11.5567C5.84523 11.5549 5.94454 11.5329 6.03654 11.4919C6.12854 11.4509 6.21134 11.3918 6.28 11.3181L8 9.59809L9.72 11.3181C9.78866 11.3918 9.87146 11.4509 9.96346 11.4919C10.0555 11.5329 10.1548 11.5549 10.2555 11.5567C10.3562 11.5585 10.4562 11.5399 10.5496 11.5022C10.643 11.4645 10.7278 11.4083 10.799 11.3371C10.8703 11.2659 10.9264 11.1811 10.9641 11.0877C11.0018 10.9943 11.0204 10.8943 11.0186 10.7936C11.0168 10.6929 10.9948 10.5935 10.9538 10.5015C10.9128 10.4095 10.8537 10.3267 10.78 10.2581L9.06 8.53809L10.78 6.81809C10.9125 6.67591 10.9846 6.48786 10.9812 6.29356C10.9777 6.09926 10.899 5.91388 10.7616 5.77646C10.6242 5.63905 10.4388 5.56034 10.2445 5.55691C10.0502 5.55348 9.86217 5.62561 9.72 5.75809L8 7.47809L6.28 5.75809Z"
              fill="currentColor" />
          </svg>
          <svg *ngIf="!appliedStartDate && !appliedEndDate" class="filter-arrow" width="12" height="8"
            viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
      </div>
    </div>
    }
  </div>
  <!-- <div class="d-flex align-items-center justify-content-center flex-column" *ngIf="error_message != ''">
    <div class="text-center" style="color: var(--header_text_not_selected)">
      No Events Found
    </div>
  </div> -->
  <div id="st_all_events_no_records_container"
    class="d-flex align-items-center justify-content-center flex-column h-100"
    *ngIf="events_list?.length == 0 && !isLoading && viewMode !== 'map'">
    <stupa-empty-state purpose="no-results" [title]="'No results found'"
      [description]="'Try adjusting your filters or search to find what you\'re looking for.'" />
  </div>
  @if (isLoading && events_list?.length === 0 && viewMode !== 'map') {
  @if (grid_view) {
  <div id="st_all_events_skeleton_grid" class="grid-event-card-wrapper">
    @for (card of skeletonCards; track card) {
    <stupa-skeleton-loader variant="card" />
    }
  </div>
  } @else {
  <stupa-skeleton-loader id="st_all_events_skeleton_list" class="p-3" [rows]="8" [columns]="6" />
  }
  }
  <ng-container *ngIf="viewMode === 'map'">
    <stupa-event-map-view class="d-block min-w-0" [events]="displayedEvents" [origin]="nearMeOrigin"
      [layoutWide]="screenWidth > 1024" [isLoading]="isLoading" (openEvent)="go_to_event($event)"
      (registerEvent)="onRegister($event)" (loadMore)="loadMoreEvents()" (viewportChange)="onMapViewport($event)">
    </stupa-event-map-view>
  </ng-container>
  <ng-container *ngIf="events_list?.length > 0 && viewMode !== 'map'">
    <ng-template [ngTemplateOutlet]="listEvents"
      [ngTemplateOutletContext]="{ events: displayedEvents, grid: grid_view }"></ng-template>
  </ng-container>

  <!-- Loading indicator for infinite scroll -->
  <div id="st_all_events_loading_indicator" class="py-4 d-flex justify-content-center align-items-center"
    *ngIf="isLoading && events_list?.length > 0 && viewMode !== 'map'">
    @if (grid_view) {
    <div id="st_all_events_more_skeleton_grid" class="grid-event-card-wrapper w-100">
      @for (card of skeletonCards.slice(0, 3); track card) {
      <stupa-skeleton-loader variant="card" />
      }
    </div>
    } @else {
    <stupa-skeleton-loader id="st_all_events_more_skeleton_list" [rows]="3" [columns]="6" />
    }
  </div>

  <!-- End of data indicator -->
  <!-- <div 
    class="py-4 d-flex justify-content-center align-items-center text-muted" 
    *ngIf="!hasMoreData && events_list.length > 0 && !isLoading"
  >
    <span>No more events to load</span>
  </div> -->

  <!-- <stupa-mobile-search *ngIf="mobile_search" (searchSubmit)="onSearchSubmit($event)"
    [searchQuery]="searchQuery"></stupa-mobile-search> -->
</div>
}

<ng-template #listEvents let-events="events" let-grid="grid">
  @if (grid) {
    <!-- Grid cards are a fixed 400px tall, so rows can be virtualized against the page (window) scroll:
         no inner scrollbar, and the window:scroll load-more keeps working. -->
    <cdk-virtual-scroll-viewport
      #allEventsGridViewport
      scrollWindow
      id="st_all_events_list_grid_wrapper"
      class="all-events-viewport"
      [style.--events-grid-cols]="gridColumns"
      [itemSize]="gridRowHeight"
      [minBufferPx]="gridRowHeight * 4"
      [maxBufferPx]="gridRowHeight * 8"
      (scrolledIndexChange)="onViewportScrolled(allEventsGridViewport)"
    >
      <div
        *cdkVirtualFor="let row of eventRows; trackBy: trackByRow; let rowIndex = index"
        class="grid-event-card-row"
        [class.grid-event-card-wrapper2]="events.length < 3"
      >
        @for (item of row; track item.id; let colIndex = $index) {
          <stupa-tournament-card
            [rowIndex]="rowIndex * gridColumns + colIndex"
            [priority]="rowIndex === 0"
            [image]="item.thumbnail || item.banner || item.logo || item.event_thumbnail || item.event_banner"
            [status]="item.event_status"
            [closesIn]="item.registration_closes_in"
            [endDate]="item.event_end_date"
            [dateRange]="(item.event_start_date | date: 'MMMM dd, yyyy') + ' - ' + (item.event_end_date | date: 'MMMM dd, yyyy')"
            [title]="item.name"
            [location]="getLocation(item)"
            [distanceKm]="eventKm(item)"
            [registeredCount]="item.registered_participants || 0"
            [buttonText]="item.buttonText"
            (register)="onRegister(item)"
            (newRegister)="onNewRegister(item)"
            (cardClick)="go_to_event(item)"
            (viewRegisterCount)="onViewRegisterCount(item)"
            (showLogin)="openLoginPopup()"
            [event_id]="item.id"
            [eventData]="item"
            (viewDetails)="go_to_event(item)"
            [isBroadcastRoute]="isBroadcastRoute"
          >
          </stupa-tournament-card>
        }
      </div>
    </cdk-virtual-scroll-viewport>
  } @else {
    <!-- List rows are not virtualized: their height varies (wrapping status pills, the stacked
         tablet/mobile layout), which a fixed-size virtual scroller would mis-position, and the zebra
         striping relies on the rows being siblings. -->
    <div id="st_all_events_list_grid_wrapper" class="row-event-card-wrapper d-flex flex-column gap-2 p-3"
      [class.row-event-card-wrapper--broadcast]="isBroadcastRoute">
      <div id="st_all_events_list_header" class="event-list-header fs-13 fw-medium">
        <span class="event-list-header__cell event-list-header__cell--name fw-semibold">
          {{ 'event_name' | translate }}
        </span>
        @if (!isBroadcastRoute) {
        <span class="event-list-header__cell fw-semibold">{{ 'organiser' | translate }}</span>
        }
        <span class="event-list-header__cell fw-semibold">{{ 'event_status' | translate }}</span>
        @if (!isBroadcastRoute) {
        <span class="event-list-header__cell fw-semibold">{{ 'event_level' | translate }}</span>
        }
        <span class="event-list-header__cell fw-semibold">{{ 'event_type' | translate }}</span>
        <span class="event-list-header__cell fw-semibold">{{ 'actions' | translate }}</span>
      </div>
      @for (item of events; track item.id) {
      <stupa-event-list-card [grid]="false" [item]="item" [is_sublicense]="is_sub_license"
        [user_role_id]="user_role_id" [event_tab_index]="selected_tab" [organiserDetails]="getOrganiserDetails(item)"
        [isBroadcastRoute]="isBroadcastRoute" [rowIndex]="$index"></stupa-event-list-card>
      }
    </div>
  }
</ng-template>

@if (screenWidth <= 1024) { <stupa-event-discovery-filter-drawer [visible]="mobileFiltersOpen"
  [isBroadcast]="isBroadcastRoute" [nearMe]="pendingNearMe" [dateSelected]="!!dates?.length"
  [statuses]="eventStatusOptions" [seasons]="seasons_list" [levels]="eventLevelOptions"
  [selectedStatus]="pendingEventStatus" [selectedSeason]="pendingSeason" [selectedLevel]="pendingEventLevel"
  (closed)="onMobileFiltersClosed()" (applied)="applyMobileFilters()" (cleared)="clearMobileFilters()"
  (nearMeChange)="pendingNearMe = $event" (statusToggle)="toggleDiscoveryOption('status', $event)"
  (seasonToggle)="toggleDiscoveryOption('season', $event)" (levelToggle)="toggleDiscoveryOption('level', $event)">
  @if (mobileFiltersOpen) {
  <div date-panel>
    <ng-container *ngTemplateOutlet="dateRangePicker; context: { embedded: true }"></ng-container>
  </div>
  }
  </stupa-event-discovery-filter-drawer>
  }

  <!-- Date-range picker. Desktop opens it from the chip; mobile embeds it in the filter drawer. -->
  @if (screenWidth > 1024) {
  <p-overlayPanel #dateRangeOverlay appendTo="body" styleClass="date-range-overlay-panel">
    <ng-container *ngTemplateOutlet="dateRangePicker; context: { embedded: false }"></ng-container>
  </p-overlayPanel>
  }
  <ng-template #dateRangePicker let-embedded="embedded">
    <div id="st_all_events_date_range_panel" class="st-drp" [class.st-drp--embedded]="embedded">
      <div id="st_all_events_date_presets" class="st-drp-presets d-flex flex-column gap-1 p-2" role="group"
        [attr.aria-label]="'select_date' | translate">
        @for (preset of datePresets; track preset.id) {
        <button type="button" class="st-drp-preset fs-13 fw-medium text-start px-2 py-2"
          [class.st-drp-preset--active]="activeDatePreset() === preset.id"
          [attr.aria-pressed]="activeDatePreset() === preset.id" (click)="applyDatePreset(preset.id)">
          {{ preset.labelKey | translate }}
        </button>
        }
      </div>
      <div class="st-drp-main">
        <div id="st_all_events_date_range_header" class="st-drp-header gap-2">
          <button type="button" class="st-drp-nav-btn" aria-label="Previous month" (click)="prevMonths()">
            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M5.77993 9.78066C5.6393 9.92111 5.44868 10 5.24993 10C5.05118 10 4.86055 9.92111 4.71993 9.78066L0.469928 5.53066C0.329478 5.39003 0.250588 5.19941 0.250588 5.00066C0.250588 4.80191 0.329478 4.61129 0.469928 4.47066L4.71993 0.22066C4.8621 0.0881804 5.05015 0.016056 5.24445 0.0194845C5.43875 0.0229129 5.62414 0.101625 5.76155 0.239038C5.89896 0.376451 5.97768 0.561837 5.9811 0.756138C5.98453 0.950438 5.91241 1.13848 5.77993 1.28066L2.05993 5.00066L5.77993 8.72066C5.92038 8.86129 5.99927 9.05191 5.99927 9.25066C5.99927 9.44941 5.92038 9.64003 5.77993 9.78066Z"
                fill="currentColor" />
            </svg>
          </button>

          <select id="st_all_events_drp_year_select" class="st-drp-year-select fs-12 fw-medium"
            [(ngModel)]="selectedYear" (change)="onYearJump()" [attr.aria-label]="'select_year'|translate">
            <option [id]="'st_all_events_drp_year_option' + idx"
              *ngFor="let year of yearRange; let idx = index; trackBy: trackByIndex" [ngValue]="year">{{ year }}
            </option>
          </select>

          <div class="st-drp-columns st-drp-columns-header">
            <div [id]="'st_all_events_drp_month_title' + idx" class="st-drp-column"
              *ngFor="let month of visibleMonths; let idx = index; trackBy: trackByIndex">
              <span class="st-drp-month-title fs-14 fw-semibold">{{ month.name }} {{ month.year }}</span>
            </div>
          </div>

          <button type="button" class="st-drp-nav-btn" aria-label="Next month" (click)="nextMonths()">
            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.220073 0.21934C0.360698 0.0788894 0.551322 0 0.750072 0C0.948823 0 1.13945 0.0788894 1.28007 0.21934L5.53007 4.46934C5.67052 4.60997 5.74941 4.80059 5.74941 4.99934C5.74941 5.19809 5.67052 5.38871 5.53007 5.52934L1.28007 9.77934C1.1379 9.91182 0.949852 9.98394 0.75555 9.98052C0.561249 9.97709 0.375864 9.89837 0.238451 9.76096C0.101038 9.62355 0.0223253 9.43816 0.0188971 9.24386C0.0154688 9.04956 0.0875927 8.86152 0.220073 8.71934L3.94007 4.99934L0.220073 1.27934C0.0796223 1.13871 0.000732422 0.948091 0.000732422 0.74934C0.000732422 0.550589 0.0796223 0.359965 0.220073 0.21934Z"
                fill="currentColor" />
            </svg>
          </button>
        </div>

        <div id="st_all_events_date_range_body" class="st-drp-columns st-drp-columns-body">
          <div [id]="'st_all_events_drp_month' + idx" class="st-drp-column"
            *ngFor="let month of visibleMonths; let idx = index; trackBy: trackByIndex">
            <div class="st-drp-weekdays">
              <span [id]="'st_all_events_drp_weekday' + idx + '_' + idx2" class="st-drp-weekday fs-11" [title]="day"
                *ngFor="let day of weekDays; let idx2 = index; trackBy: trackByIndex">{{ day.charAt(0) }}</span>
            </div>
            <div class="st-drp-days">
              <button type="button" [id]="'st_all_events_drp_day' + idx + '_' + idx2" class="st-drp-day"
                *ngFor="let day of month.days; let idx2 = index; trackBy: trackByIndex" [class.st-drp-day-empty]="!day"
                [class.st-drp-in-range]="day?.inRange" [class.st-drp-round-l]="day?.roundLeft"
                [class.st-drp-round-r]="day?.roundRight" [class.st-drp-boundary]="day?.isRangeStart || day?.isRangeEnd"
                [disabled]="!day || day.disabled" (click)="day && !day.disabled && toggleDateSelection(day.dateStr)">
                <span class="st-drp-day-number fs-13">{{ day?.date }}</span>
              </button>
            </div>
          </div>
        </div>

        @if (!embedded) {
        <div id="st_all_events_date_range_footer" class="st-drp-footer">
          <div class="st-drp-footer-info">
            <i class="pi pi-calendar st-drp-footer-icon"></i>
            <div class="st-drp-footer-text">
              <span class="st-drp-footer-caption fs-11">{{'select_range_to_filter'|translate}}</span>
              <span *ngIf="dates && dates.length > 0"
                class="st-drp-footer-value fs-13 fw-semibold">{{getSelectedDatesText()}}</span>
              <span *ngIf="!dates || dates.length === 0"
                class="st-drp-footer-value st-drp-placeholder fs-13">{{'no_dates_selected'|translate}}</span>
            </div>
          </div>
          <div class="st-drp-footer-actions">
            <button type="button" class="st-drp-btn st-drp-btn-cancel fs-13 fw-medium"
              (click)="closeCalendar()">{{'cancel'|translate}}</button>
            <button type="button" class="st-drp-btn st-drp-btn-apply fs-13 fw-medium"
              (click)="applyDates()">{{'apply'|translate}}</button>
          </div>
        </div>
        }
      </div>
    </div>
  </ng-template>

  <p-overlayPanel #op appendTo="body">
    <div id="st_all_events_mobile_filter_overlay" class="filter_overlay">
      @for(item of event_statuses ; track item){
      <div [id]="'st_all_events_status_checkbox' + (item.id ?? item)"
        class="gap-2 my-2 d-flex align-items-center check_box">
        <p-checkbox [(ngModel)]="item.checked" [binary]="true" [id]="item.value"
          (onChange)="onStatusChange($event, item.value)" [value]="item.value" inputId="binary" />
        <label [for]="item.value" class="title"> {{ item.title }}</label>
      </div>
      }
    </div>
  </p-overlayPanel>
